export default "d5a5320ee37d861c.svg"